// extracted by mini-css-extract-plugin
export default {"select":"select_select__-2P1j"};